// styling
import {colors} from '@styles/vars';

// styled components
import {Header} from './style';

// components
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Logo from '@ui/Logo';
import MenuButton from '@ui/MenuButton';
import Content from './Content';
import PortalContent from './PortalContent';
import {authService} from '@services/auth.service';

// hooks
import {useSidebarContext} from '@contexts/sidebarContext';
import {useWindowSize} from 'react-use';
import {useInterfaceContext} from '@contexts/interfaceContext';
import {useTheme} from 'styled-components';

const Sidebar = () => {
    const {theme} = useTheme();
    const {isSidebarOpen, toggleSidebar, isCollapsed, toggleCollapse} = useSidebarContext();
    const {direction} = useInterfaceContext();
    const {width} = useWindowSize();
    const isMobile = width < 768, isDesktop = width >= 1366;
    const isPortalShell = authService.shouldUseClientPortalShell();

    return (
        <SwipeableDrawer open={!isDesktop ? isSidebarOpen : true}
                         onClose={toggleSidebar}
                         onOpen={toggleSidebar}
                         PaperProps={{
                             style: {
                                 width: isMobile ? '100%' : (isCollapsed ? 'var(--drawer-width-collapsed)' : 'var(--drawer-width)'),
                                 height: 'calc(100% + 1px)',
                                 flexDirection: 'column',
                                 padding: isMobile ? '20px' : (isCollapsed ? '20px' : '40px'),
                                 borderRightColor: theme === 'dark' ? colors.dark : colors.light_gray,
                                 right: direction === 'rtl' ? 0 : 'auto',
                                 left: direction === 'rtl' ? 'auto' : 0,
                                 transition: 'width 0.25s cubic-bezier(0.4, 0, 0.2, 1), padding 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                                 overflow: 'hidden'
                             },
                             className: `sidebar ${isCollapsed ? 'collapsed' : ''}`,
                         }}
                         BackdropProps={{
                             style: {
                                 backgroundColor: 'rgba(0, 0, 0, 0.7)',
                             }
                         }}
                         transitionDuration={{
                             enter: 200,
                             exit: 150
                         }}
                         sx={{
                             zIndex: 20000
                         }}
                         variant={isDesktop ? 'persistent' : 'temporary'}>
            <Header>
                <Logo isCollapsed={isCollapsed}/>
                <MenuButton/>
            </Header>
            {!isMobile && isDesktop && (
                <button 
                    onClick={toggleCollapse}
                    style={{
                        position: 'absolute',
                        top: '50%',
                        right: '-12px',
                        width: '24px',
                        height: '48px',
                        background: theme === 'dark' ? colors.dark : colors.light_gray,
                        border: `1px solid ${theme === 'dark' ? colors.dark : colors.light_gray}`,
                        borderRadius: '0 8px 8px 0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'background 0.2s ease',
                        zIndex: 1
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = colors.blue}
                    onMouseLeave={(e) => e.currentTarget.style.background = theme === 'dark' ? colors.dark : colors.light_gray}
                    aria-label={isCollapsed ? 'Expandir sidebar' : 'Colapsar sidebar'}
                >
                    <i className={`icon-chevron-${isCollapsed ? 'right' : 'left'}`} style={{fontSize: '12px', color: '#fff'}}></i>
                </button>
            )}
            {isPortalShell ? (
                <PortalContent isCollapsed={isCollapsed}/>
            ) : (
                <Content isCollapsed={isCollapsed}/>
            )}
        </SwipeableDrawer>
    )
}

export default Sidebar;